import { useContext } from "react";
import { getPartnerMarketing } from "app/reducers/partnerSelector";
import { useSelector, shallowEqual } from "react-redux";
import SmartDPMarketingHeroImage from "app/pages/SmartDP/SmartDPMarketingHeroImage/SmartDPMarketingHeroImage";
import AppGlobalsContext from "app/AppGlobalsContext";
import { RESOLUTION } from "app/pages/.shared/responsive/responsiveReducer";
import PropTypes from "prop-types";

const SmartDPMarketingHeroImageContainer = props => {
	const stateProps = useSelector(state => mapStateToProps(state, props), shallowEqual);
	const {
		heroImageMobile,
		heroImageDesktop,
		heroImageMobileThumbnail,
		heroImageDesktopThumbnail,
		sizes,
		backgroundPosition,
		alt,
	} = { ...props, ...stateProps };
	const { resolution } = useContext(AppGlobalsContext);
	const isMobile = resolution === RESOLUTION.SMALL;
	const backgroundImageUrl = isMobile ? heroImageMobile : heroImageDesktop;
	const backgroundImageThumbnail = isMobile
		? heroImageMobileThumbnail
		: heroImageDesktopThumbnail;
	return (
		<SmartDPMarketingHeroImage
			imageUrl={backgroundImageUrl}
			imageThumbnail={backgroundImageThumbnail}
			sizes={sizes}
			resolution={resolution}
			backgroundPosition={backgroundPosition}
			alt={alt}
		/>
	);
};

SmartDPMarketingHeroImageContainer.propTypes = {
	heroImageMobile: PropTypes.string,
	heroImageDesktop: PropTypes.string,
	heroImageMobileThumbnail: PropTypes.string,
	heroImageDesktopThumbnail: PropTypes.string,
	sizes: PropTypes.object,
	backgroundPosition: PropTypes.string,
	alt: PropTypes.string,
};

const mapStateToProps = (state, props) => {
	const marketing = getPartnerMarketing(state);
	const {
		heroImageMobile,
		heroImageDesktop,
		heroImageMobileThumbnail,
		heroImageDesktopThumbnail,
	} = props;
	return {
		heroImageMobile: heroImageMobile || marketing?.heroImageMobile,
		heroImageDesktop: heroImageDesktop || marketing?.heroImageDesktop,
		heroImageMobileThumbnail: heroImageMobileThumbnail || marketing?.heroImageMobileThumbnail,
		heroImageDesktopThumbnail:
			heroImageDesktopThumbnail || marketing?.heroImageDesktopThumbnail,
	};
};

export default SmartDPMarketingHeroImageContainer;
